/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// @ts-ignore
import s from './Tag.css';

class Tag extends React.Component {
  constructor (props) {
    super(props)


    this.clickHandle = this.clickHandle.bind(this)
  }

  clickHandle () {
    const onClick = this.props.onClick
    typeof onClick === 'function' && onClick()
  }

  render() {
    return(
      <span
        className={[s.root, this.props.className].join(' ')}
        onClick={this.clickHandle}
      > {this.props.children} </span>
    )
  }
}

export default withStyles(s)(Tag);



// WEBPACK FOOTER //
// src/components/Tag/Tag.js